import { useTranslation } from "react-i18next";
import React, {useEffect} from "react";
import { Container, Row } from "react-bootstrap";
import ClassResultsIcon from '../../images/ClassResults.svg';
import YourResultsIcon from '../../images/YourResults.svg';


import "bootstrap/dist/css/bootstrap.css";
import "./styles.css";
import { newPageLog } from "../../utils/helpers";

export default function OverallResultsPage({

}) {
    const { t } = useTranslation();

  const class1 = "2/2";
  const class2 = "100%";
  const class3 = "50pts";

  const handleHome = () => {
    console.log("home");
  }

  useEffect(() => {
    newPageLog("OverallResultsPage.js");
  }, []);


  return (
    <div>
      <Container className="results-wrap">

        <div>
          <Row><p className="results-title">{t("poll.overallResults")}</p></Row>
          <Row><p className="results-sub-title">{t("poll.overallResultsDesc")}</p></Row>
        </div>

        <div className="results-box-title">
          <img className="results-box-title-img" src={ClassResultsIcon}></img>
          <p className="results-box-title-text">{t("poll.classResults")}</p>
        </div>

        <div className="results-box-body">
          <Row><div className="results-box-body-head">
            <p className="results-prop-name">{t("poll.overallScoreLabel")} </p>
            <p className="results-prop-val">{class1}</p>
          </div></Row>

          <Row><div className="results-box-body-head">
            <p className="results-prop-name">{t("poll.gradePercentageLabel")} </p>
            <p className="results-prop-val">{class2}</p>
          </div></Row>

          <Row><div className="results-box-body-head">
            <p className="results-prop-name">{t("poll.pointsEarnedLabel")} </p>
            <p className="results-prop-val">{class3}</p>
          </div></Row>
        </div>

        <div><br></br></div>

        <div className="results-box-title">
          <img className="results-box-title-img" src={YourResultsIcon}></img>
          <p className="results-box-title-text">{t("poll.yourResults")}</p>
        </div>

        <div className="results-box-body">
          <Row><div className="results-box-body-head">
            <p className="results-prop-name">{t("poll.overallScoreLabel")} </p>
            <p className="results-prop-val">{class1}</p>
          </div></Row>

          <Row><div className="results-box-body-head">
            <p className="results-prop-name">{t("poll.gradePercentageLabel")} </p>
            <p className="results-prop-val">{class2}</p>
          </div></Row>

          <Row><div className="results-box-body-head">
            <p className="results-prop-name">{t("poll.pointsEarnedLabel")} </p>
            <p className="results-prop-val">{class3}</p>
          </div></Row>
        </div>

        <div><br></br><br></br></div>

        <div className="results-btn-wrap">
          <Row>
            <button onClick={() => handleHome()} className="results-home-btn">
              <span className="results-home-btn-text">{t("navigation.home")}</span>
            </button>
          </Row>
        </div>

      </Container>
    </div>
  );
}
